<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>


    <v-dialog v-model="faturadialoggoster" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>{{ $t('E-Invoice') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <div class="flex md12">
              <span id="demo2"> </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="faturadialog" width="500">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{$t('Attention')}} !</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{ dialogmesaj }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="mesajiptal()">
            {{ $t("cancel_button") }}
          </v-btn>
          <v-btn color="primary" flat @click="faturala()">
            {{$t('Invoice')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Print-Invoice') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="search3"
                 :label="this.$t('Search')"
                append-icon="search"
              >
              </v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-dialog
            v-model="dialogfiltre"
            scrollable=""
            persistent=""
            max-width="750px"
          >
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">
                        <v-flex xs12 sm6 md6>
                          <v-layout justify-space-between column>
                            <masrafmerkezicomp
                              v-model="faturaList.Filtreler.Masraf"
                            ></masrafmerkezicomp>
                            <referansmerkezicomp
                              v-model="faturaList.Filtreler.Referans"
                              :coper="false"
                            ></referansmerkezicomp>
                            <v-select
                              :items="hesapgurubu"
                              clearable=""
                              hide-details=""
                              v-model="faturaList.Filtreler.HesapGrubu"
                              :label="$t('Account-Group')"
                              item-text="Adi"
                              item-value="Kod"
                              max-height="400"
                            ></v-select>

                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="gdsitems"
                              label="GDS"
                              multiple
                              item-text="text"
                              v-model="faturaList.Filtreler.GDSler"
                              item-value="value"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.text }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.GDSler.length - 1
                                  }}
                                   {{ $t('Other') }}   )</span
                                >
                              </template>
                            </v-autocomplete>

                            <v-flex xs12 sm6 md6>
                              <v-checkbox
                                hide-details=""
                                v-model="faturaList.Filtreler.SifirTutar"
                                :label="$t('Not-Invoice-Tickets-with-Zero-Amounts')"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-layout justify-space-between column>
                            <bolumcomp
                              v-model="faturaList.Filtreler.BolumKodu"
                            ></bolumcomp>
                            <v-text-field
                              v-model="faturaList.Filtreler.SiparisNo"
                              :label="$t('Order-No')"
                              hide-details=""
                            >
                            </v-text-field>

                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="itemsairlinelist"
                              :label="$t('Select-Airline')"
                              multiple
                              item-text="Title"
                              v-model="faturaList.Filtreler.Havayollari"
                              item-value="HavaYoluKodu"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.Title }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.Havayollari.length - 1
                                  }}
                                  {{ $t('Other') }})</span
                                >
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="odemesekli"
                              :label="$t('Select-Payment-Method')"
                              multiple
                              item-text="text"
                              v-model="faturaList.Filtreler.Odemeler"
                              item-value="value"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.text }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.Odemeler.length - 1
                                  }}
                                  {{ $t('Other') }})</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <br />
                          <div class="card__text info white--text">
                            <h3>&nbsp; {{ $t('Options-v2') }}</h3>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              :label="$t('Record-Type')"
                              v-model="faturaList.Filtreler.RecordType"
                            >
                              <v-radio :label="$t('All')" value="4"></v-radio>
                              <v-radio :label="$t('Ticket')" value="0"></v-radio>
                              <v-radio :label="$t('Seat')" value="1"></v-radio>
                              <v-radio :label="$t('Meal')" value="2"></v-radio>
                              <v-radio :label="$t('Additional-Luggage')" value="3"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.TarihTipi"
                              :label="$t('Date-Type')"
                              column
                            >
                              <v-radio :label="$t('Sales-Date')" :value="'0'">
                              </v-radio>
                              <v-radio
                                :label="$t('Sales') + ' - ' +  $t('Flight-Date')"
                                :value="'1'"
                              ></v-radio>
                              <v-radio
                                :label=" $t('Sales') +'-'+$t('Date-of-Return')"
                                :value="'2'"
                              ></v-radio>
                              <v-radio
                                :label=" $t('Sales-Flight') + ' - ' + $t('Date-of-Return')"
                                :value="'3'"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.CariTip"
                              :label="$t('Customertype_label')"
                              column
                            >
                              <v-radio :label="$t('All-v2')" :value="'0'"> </v-radio>
                              <v-radio :label="$t('Individual')" :value="'1'"></v-radio>
                              <v-radio :label="$t('Corporate')" :value="'2'"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.UcusTip"
                              :label="$t('Cyprus-Batum-Flights')"
                              column
                            >
                              <v-radio
                                :label="$t('Except-ECN-BUS')"
                                :value="'1'"
                              ></v-radio>
                              <v-radio
                                :label="$t('Only-ECN-BUS')"
                                :value="'2'"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              :label="$t('E-Invoice-Status')"
                              v-model="faturaList.Filtreler.EFaturaKayitli"
                              column
                            >
                              <v-radio
                                :label="$t('Not-Registered-with-E-invoice')"
                                :value="false"
                              >
                              </v-radio>
                              <v-radio
                                :label="$t('E-Invoice-Registered-Client')"
                                :value="true"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.HatBilgi"
                              :label="$t('Line-Type')"
                              column
                            >
                              <v-radio :label="$t('Domestic-Line')" :value="false"> </v-radio>
                              <v-radio :label="$t('International-Line')" :value="true"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" flat @click.native="getList()"
                  > {{ $t('Find-Records') }} </v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogopsiyon"
            scrollable=""
            persistent=""
            max-width="400px"
          >
            <v-card color="grey lighten-5">
              <v-card-title> {{ $t('Select-Option') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <tarihcomp
                        :etiket="$t('Invoice-Date')"
                        v-bind:defaultvalue="'ok'"
                        v-bind:value="faturaList.FaturaTarih"
                        v-model="faturaList.FaturaTarih"
                      ></tarihcomp>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-select
                        :items="gibSeri1"
                        hide-details=""
                        v-model="faturaList.GibSeri"
                        :label="$t('Turkish-Revenue-Administration-Serial-No')"
                        item-text="Seri"
                        item-value="Seri"
                        max-height="400"
                      ></v-select>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-text-field
                        mask="AAA"
                        :label="$t('Paper-Invoice-Serial')"
                        hide-details=""
                        v-model="faturaList.FaturaSeri"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-text-field
                        hide-details=""
                        mask="###########################"
                        :label="$t('Paper-Inv-Head-No')"
                        v-model="faturaList.FaturaNo"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="dizaynsec"
                      @change="xsltsec(faturaList.FaturaBilgi.FaturaID)"
                      v-model="faturaList.FaturaBilgi.FaturaID"
                      hide-details=""
                      item-text="FaturaAciklama"
                      item-value="FaturaId"
                      :label="$t('Select-Design')"
                    ></v-select>
                    <!-- <v-select :items="xsltitems" v-model="faturaList.FaturaBilgi.FaturaXSLTID" hide-details=""
                      clearable item-text="XsltAciklama" item-value="FaturaId" :label="$t('Select-xslt-File')"></v-select> -->
                    <reportbrosablon
                      v-show="false"
                      ref="reportbrosablon"
                      v-model="faturaList.FaturaBilgi.FaturaPdfID"
                      dizayngrupadi="Fatura"
                      objectname="Controllers.ReportBro.Invoice.InvoicePrint"
                    ></reportbrosablon>
                    <v-textarea
                      hide-details=""
                      v-model="faturaList.FaturaBilgi.FaturaDipAciklama"
                      :label="$t('E-invoice-Footer-Disclosure')"
                    ></v-textarea>
                   <v-flex xs12 sm12 md12 v-if="isCurrentSame">
                        <v-switch  label="Ünvan Bilgilerini Değiştir" v-model="changeTitleInfo"></v-switch>
                    </v-flex> 
                   <v-flex xs12 sm12 md12 v-if="changeTitleInfo">
                    <v-text-field hide-details=""  :label="$t('Title_label') + '1'" v-model="faturaList.EFaturaBilgi.Unvani"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Title_label') + '2'" v-model="faturaList.EFaturaBilgi.Unvani2"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Address_label') + '1'" v-model="faturaList.EFaturaBilgi.Adres1"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Address_label') + '2'" v-model="faturaList.EFaturaBilgi.Adres2"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Province_label')" v-model="faturaList.EFaturaBilgi.IlceSehir"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Invoice-E-mail')" v-model="faturaList.EFaturaBilgi.Email"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Taxcenter_label')" v-model="faturaList.EFaturaBilgi.VergiDairesi">
                    </v-text-field>
                    <v-text-field hide-details=""  :label="$t('Taxnumber_label')" v-model="faturaList.EFaturaBilgi.VergiNo"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Identity-Number')" v-model="faturaList.EFaturaBilgi.TcKimlikNo">
                    </v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.Adi" :label="$t('Name_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.Soyadi" :label="$t('Surname_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.TUnvani" :label="$t('Title_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.DigerAdi" :label="$t('Othername_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.OnAdiEki" :label="$t('Suffixname_label')"></v-text-field>
                  
                  </v-flex> 
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <br />
                    <div class="card__text info white--text">
                      <h3>&nbsp; {{ $t('Options-v2') }}</h3>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          v-model="faturaList.Opsiyonlar.FaturaTekSatir"
                          :label="$t('Write-Invoice-in-Single-Line')"
                          hide-details=""
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          hide-details=""
                          v-model="faturaList.Opsiyonlar.OdemeSekliGrup"
                          :label="$t('Group-Payment-Method')"
                        ></v-checkbox>
                      </v-flex>
                      <v-layout>
                        <v-checkbox
                          v-model="faturaList.Opsiyonlar.DovizliFatura"
                          :label="$t('Foreign-Currency-Invoice')"
                          hide-details=""
                        ></v-checkbox>
                        <v-flex xs12 sm3 md4>
                          <v-autocomplete
                            v-if="dovizlifaturami"
                            hide-details=""
                            @change="kurgetir(faturaList.DovizBilgi.DDovizTipi)"
                            :items="doviztipi"
                            v-model="faturaList.DovizBilgi.DDovizTipi"
                            clearable
                            item-text="Title"
                            item-value="DovizKod"
                            :label="$t('Currency-Type')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm3 md3>
                          <dovizinput
                            v-if="dovizlifaturami"
                            v-model="faturaList.DovizBilgi.DKur"
                            :etiket="$t('Exchange-Amount')"
                          >
                          </dovizinput>
                        </v-flex>
                      </v-layout>
                      <v-checkbox
                        :label="$t('Do-Not-Print-Passenger-Name')"
                        v-model="faturaList.Opsiyonlar.YolcuGosterme"
                        hide-details=""
                      ></v-checkbox>
                      <v-checkbox
                        :label="$t('Do-Not-Print-Payment-Term')"
                        v-model="faturaList.Opsiyonlar.OdemeVade"
                        hide-details=""
                      ></v-checkbox>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          hide-details=""
                          v-model="faturaList.Opsiyonlar.FaturaDetayBas"
                          :label="$t('Print-Invoice-Details')"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
         
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="opsiyoniptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" :disabled="currentSearchControl" flat @click.native="faturalasor()"
                  >{{$t('Invoice')}}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-container fluid="">
            <v-card flat>
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-model="faturaList.Filtreler.BaslangicTarih"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="faturaList.Filtreler.BaslangicTarih"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="faturaList.Filtreler.BitisTarih"
                    v-model="faturaList.Filtreler.BitisTarih"
                  >
                  </tarihcomp>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <cariaracomp
                    v-bind:etiket="$t('Select-Starting-Current')"
                    v-bind:value="faturaList.Filtreler.BaslangicCariKod"
                    :loading="loading"
                    v-model="faturaList.Filtreler.BaslangicCariKod"
                  ></cariaracomp>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <cariaracomp
                    ref="bitisCariAyarla"
                    v-bind:etiket="$t('Select-Ending-Current')"
                    v-bind:value="faturaList.Filtreler.BitisCariKod"
                    :loading="loading2"
                    v-model="faturaList.Filtreler.BitisCariKod"
                    v-bind:statecariyedek="statecari2"
                    @sendCurrentData="getCurrentData($event)"
                  ></cariaracomp>
                </v-flex>

                <v-flex>
                  <v-layout align-center="" justify-start="" fill-height>
                    <!-- <v-btn v-if="devam1btn" color="info" @click="filtrele()" dark>
                      Kayıt Ara
                    </v-btn> -->

                    <div v-if="load1">
                      <v-btn color="info" @click="filtrele()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div v-if="load1">
                      <!-- <v-badge color="green" right overlap>
                        <v-icon v-if="filtreok" slot="badge" dark small>done</v-icon>
                      <v-icon @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="grey lighten-1" large>
                        filter_list
                      </v-icon> -->
                      <!-- <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                          color="info" fab>
                          <v-icon dark>filter_list</v-icon>
                        </v-btn>
                      </v-badge>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>  -->
                    </div>
                  </v-layout>
                </v-flex>

                <v-flex v-if="kayitvarmi" xs12 sm12 md12>
                  <v-card>
                    <v-card-title>
                      <v-alert
                        :value="true"
                        color="error"
                        icon="warning"
                        outline
                      >
                        <span class="font-weight-bold body-1">
                          {{ kayitvarmesaj }}
                        </span>
                      </v-alert>

                      <v-spacer></v-spacer>
                      <v-btn
                        :disabled="seciliBiletbtn"
                        outline
                        v-show="secilibutonshow"
                        color="info"
                        @click="opsiyonlarial()"
                        dark
                      >
                      {{ $t('Continue') }}
                         <v-icon>chevron_right</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-data-table
                      v-if="carilerayni"
                      v-model="selected"
                      :headers="headers"
                      :items="itemsTicket"
                      select-all
                      item-key="BiletKod"
                      :custom-sort="customSort"
                      :search="search3"
                    >
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th>
                            <v-checkbox
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              primary
                              hide-details
                              @click.native="toggleAll"
                            ></v-checkbox>
                          </th>
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                          >
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr
                          :active="props.selected"
                          @click="props.selected = !props.selected"
                        >
                          <td>
                            <v-checkbox
                              :input-value="props.selected"
                              primary
                              hide-details
                            ></v-checkbox>
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.YolcuAdi }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.HavaYoluKodu }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.FormNo }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.BiletNo }}
                          </td>
                           <td class="text-xs-center">
                            {{ props.item.Parkurlar }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.RezervasyonAlan }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.RezervasyonVeren }}
                          </td>
                          <td class="text-xs-right">
                            {{ props.item.KdvTutar | moneyformat }}
                          </td>
                          <td class="text-xs-right">
                            {{ props.item.NetTutar | moneyformat }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>

                <v-flex v-if="faturaSonView" xs12 sm12 md12>
                  <v-card>
                    <v-data-table
                      :headers="headers2"
                      :rows-per-page-items="[20, 50]"
                      :items="faturaItems"
                      :search="search3"
                    >
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td
                            v-if="props.item.FaturaStatus == true"
                            class="text-xs-left"
                          >
                            <h3 style="color:green;">{{ $t('Successful') }} </h3>
                          </td>
                          <td
                            v-if="props.item.FaturaStatus == false"
                            class="text-xs-left"
                          >
                            <h3 style="color:red;"> {{ $t('Unsuccessful') }}  </h3>
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaResponse }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaSeri }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaNo }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaGuid }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.BiletInfo.FormNo }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.BiletInfo.BiletNo }}
                          </td>

                          <v-btn
                            v-if="props.item.FaturaStatus == true"
                            icon
                            class="mx-0"
                          >
                            <v-icon
                              color="red"
                              @click="faturayazdir(props.item)"
                              >print</v-icon
                            >
                          </v-btn>
                          <v-btn
                            v-if="props.item.FaturaStatus == true"
                            icon
                            class="mx-0"
                          >
                            <v-icon
                              color="info"
                              @click="efaturagoster(props.item)"
                              >search</v-icon
                            >
                          </v-btn>
                        </tr>
                      </template>
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="error"
                        icon="warning"
                      >
                         {{ $t('No-records-searched-for', { value: search3}) }}
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import tarihcomp from "../customcomp/tarihim";
import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import dovizinput from "@/components/app/customcomp/dovizinput.vue";
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      itemsKayitTipi: helpers.getBiletKayitTipi,
      changeTitleInfo:false,
      isCurrentSame:false,
      currentSearchControl:false,
      loadingvmodel: false,
      secilibutonshow: true,
      dovizlifaturami: false,
      kurdegeri: 0,
      kur: null,
      doviztipi: [],
      gdsitems: [],
      itemsairlinelist: [],
      kayitvarmesaj: null,
      kayitvarmi: false,
      devam1btn: true,
      devam2btn: false,
      dialogopsiyon: false,
      text1: "",
      carilerayni: false,
      selected: [],
      seciliBiletbtn: true,
      gibSeri1: [],
      itemsTicket: [],
      faturaItems: [],
      faturaSonView: false,
      hesapgurubu: [],
      dialogmesaj: this.$t('you-sure-that-want-invoice-your-tickets-your-selections'),
      faturadialog: false,
      faturaList: {
        SirketKodu: null,
        FaturaTarih: null,
        FaturaSeri: null,
        FaturaNo: null,
        GibSeri: null,
        Filtreler: {
          BaslangicCariKod: null,
          BitisCariKod: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HatBilgi: false,
          EFaturaKayitli: false,
          Masraf: null,
          SiparisNo: null,
          HavayoluKodu: null,
          HesapGrubu: null,
          TarihTipi: "0", // 0 : Satış Tarihi, 1 : Satış/Uçuş Tarihi, 2 : Satış/Donuş Tarihi , 3 : Satış/Gidiş - Donuş Tarihi
          Referans: null,
          UnvanDegistir:false,
          BolumKodu: null,
          Havayollari: [],
          Odemeler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
          GDSler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
          UcusTip: "0", // 0: Hepsi, 1 : Kıbrıs vb Hariç, 2 : Sadece Kıbrıs vb.
          SifirTutar: true,
          CariTip: "0", // 0 : Hepsi, 1 : Bireysel, 2 : Kurumsal
          RecordType: "4",
        },
        DovizBilgi: {
          EDovizTipi: null,
          EKur: 0,
          DDovizTipi: null,
          DKur: 0,
        },
        Opsiyonlar: {
          YolcuGosterme: false,
          OdemeVade: false,
          UnvanAdres: false,
          DovizliFatura: false,
          FaturaDetayBas: false,
          SifirTutarBilet: false,
          FaturaTekSatir: false,
          OdemeSekliGrup: false,
        },
        FaturaBilgi: {
          FaturaTip: null,
          FaturaID: null,
          FaturaPdfID: null,
          FaturaXSLTID: null,
          FaturaDipAciklama: null,
        },
        EFaturaBilgi:{
          Unvani:null,
          Unvani2:null,
          Adres1:null,
          Adres2:null,
          IlceSehir:null,
          Email:null,
          VergiDairesi:null,
          VergiNo:null,
          TcKimlikNo:null,
          Adi:null,
          Soyadi:null,
          TUnvani:null,
          DigerAdi:null,
          OnAdiEki:null
        }
        //public EArsivBilgileri EArsivBilgi { get; set; }
        //public FaturaDovizKur DovizBilgi { get; set; }
        //BiletBilgi: ,
        //public EfaturaBilgileri EFaturaBilgi { get; set; }
      },

      search: "",
      filtreok: false,
      odemesekli: [
        {
          text: "K-Kredili",
          value: "K",
        },
        {
          text: "P-Peşin",
          value: "P",
        },
        {
          text: this.$t('R-Card'),
          value: "R",
        },
        {
          text: this.$t('C-Card'),
          value: "C",
        },
        {
          text: this.$t('F-Card'),
          value: "F",
        },
      ],

      headers: [
        {
          text: this.$t('Name-of-Passenger'),
          value: "YolcuAdi",
          align: "center",
        },
        {
          text: this.$t('Airline-Code'),
          value: "HavaYoluKodu",
          align: "center",
        },
        {
          text: this.$t('Form-No'),
          value: "FormNo",
        },
        {
          text: this.$t('Ticket-No'),
          value: "BiletNo",
        },
        {
          text: "Parkurlar",
          value: "Parkurlar",
        },
        {
          text: "Rez. Alan",
          value: "RezervasyonAlan",
        },
        {
          text: "Rez. Veren",
          value: "RezervasyonVeren",
        },
        {
          text: this.$t('VAT-Amount'),
          value: "KdvTutar",
        },
        {
          text: this.$t('Net-Amount'),
          value: "NetTutar",
        },
      ],

      headers2: [
        {
          text: this.$t('Invoice-Status'),
          value: "FaturaStatus",
        },
        {
          text: this.$t('Invoice-Explanation'),
          value: "FaturaResponse",
        },
        {
          text: this.$t('Serial'),
          value: "FaturaSeri",
        },
        {
          text: this.$t('No'),
          value: "FaturaNo",
        },
        {
          text: "GUID",
          value: "FaturaGuid",
        },
        {
          text: this.$t('Form-No'),
          value: "BiletInfo.FormNo",
        },
        {
          text: this.$t('Ticket-No'),
          value: "BiletNo",
        },
      ],

      dizayntipi: [
        {
          text: this.$t('Default'),
          value: "D",
        },
        {
          text: this.$t('Special'),
          value: "O",
        },
      ],
      faturadialoggoster: false,
      dizaynsec: [],

      dizaynxslt: [
        {
          text: "tek değer",
          value: "0",
        },
      ],
      xsltitems: [],
      statecari: [],
      searchcari: "",
      searchcari2: "",
      Carihesap: "",
      Carihesap2: null,
      dateucus1: null,
      dateucus2: null,

      loading: false,
      loading2: false,
      yedekClass: null,
      progress: false,
      renk1: "info",
      items: [],
      load: false,
      load1: true,
      search3: "",
      statecari2: [],
      dialogfiltre: false,
      hesapkodu: [],
      masrafmerkezi: [],

      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text: "",
      tooltip: false,
      el: null,
      anaCancelValue: {},
      cancelValue: {},
      cancelOpsiyonValue: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    tarihcomp,
    bolumcomp,
    referansmerkezicomp,
    dovizinput,
    reportbrosablon,
    masrafmerkezicomp,
    yetkidialog,
    loadingcomp,
    cariaracomp,
    snackbarcomp
  },

  mounted() {
    // this.el = this.$refs.fab.$el

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // eslint-disable-next-line no-empty
    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
  watch: {
    "faturaList.FaturaTarih":function(val)
    {
if (this.faturaList.Opsiyonlar.DovizliFatura==true && this.faturaList.DovizBilgi.DDovizTipi!=null)
{
  this.kurgetir(this.faturaList.DovizBilgi.DDovizTipi);
}
    },
    "faturaList.Filtreler.BaslangicCariKod": function(val) {
      
      if(this.selected.length != 0 || this.itemsTicket.length != 0){
          this.selected = [];
          this.itemsTicket = [];
      }
      
      this.faturaList.Filtreler.BitisCariKod = val;
      this.$refs.bitisCariAyarla.carigetir(
        this.faturaList.Filtreler.BaslangicCariKod
      );
    },
    selected(val3) {
      if (val3.length > 0) {
        this.seciliBiletbtn = false;
      } else {
        this.seciliBiletbtn = true;
      }
    },
    "faturaList.Filtreler.HatBilgi": function() {
      this.dizayngetir();
    },

    // 'faturaList.FaturaBilgi.FaturaID ': function (val) {
    //   this.dizaynsec.forEach(element => {
    //     if (element.FaturaId == val) {
    //       this.faturaList.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId
    //       this.faturaList.FaturaBilgi.FaturaPdfID = element.FaturaPdfID
    //     }
    //   });
    // },
    "faturaList.Opsiyonlar.DovizliFatura": function(val) {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (val == true) {
        this.dovizlifaturami = true;

        var params1 = {
          CompanyCode: credentials.SirketKodu,
        };

        this.$http
          .post(auth.API_URL + "api/currency/List", params1, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              this.doviztipi = response.body;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              }
            }
          );
      } else {
        this.dovizlifaturami = false;
        this.faturaList.DovizBilgi.DDovizTipi = null;
        this.faturaList.DovizBilgi.DKur = 0;
      }

 
      var params = {
        SirketKodu: credentials.SirketKodu,
        FaturaTip: "O",
        HatTipi: this.faturaList.Filtreler.HatBilgi,
        TumFiltre: true,
        DovizliFatura: val,
      };

      this.$http
        .post(auth.API_URL + "api/TicketInvoice/InvoiceMainTableList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dizaynsec = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.progress = false;
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            }
          }
        );
    },
  },
  filters: {
    dateformat: function(t) {
      return helpers.dateformat(t);
    },
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function(m) {
      return helpers.bakiyekontrol(m);
    },
  },
  methods: {
    getCurrentData(val){

     this.faturaList.EFaturaBilgi.Unvani = val.Title;
     this.faturaList.EFaturaBilgi.Unvani2 = val.Title2;
     this.faturaList.EFaturaBilgi.Adres1 = val.Invoice.Address;
     this.faturaList.EFaturaBilgi.Adres2 = val.Invoice.DeliveryAddress;
     this.faturaList.EFaturaBilgi.IlceSehir = val.Invoice.Province;
     this.faturaList.EFaturaBilgi.VergiDairesi = val.Invoice.TaxOffice;
     this.faturaList.EFaturaBilgi.VergiNo = val.Invoice.TaxNumber;
     this.faturaList.EFaturaBilgi.TcKimlikNo = val.Invoice.IdentityNumber;
     this.faturaList.EFaturaBilgi.Email = val.Email;
     this.faturaList.EFaturaBilgi.Adi = val.Invoice.PerFirstName;
     this.faturaList.EFaturaBilgi.Soyadi = val.Invoice.PerFamilyName;
     this.faturaList.EFaturaBilgi.TUnvani = val.Invoice.PerTitle;
     this.faturaList.EFaturaBilgi.DigerAdi = val.Invoice.PerMiddleName;
     this.faturaList.EFaturaBilgi.OnAdiEki = val.Invoice.PerNameSuffix;
     this.currentSearchControl = false; // cari yuklemede sistem kitlenirse faturalama yapilmamasi icin kontrol ediliyor
     
    },
    customSort(items, index, isDesc) {
      items.sort();

      return items;
    },
    faturayazdir(faturainfo) {
      this.faturaList.FaturaBilgi.FaturaPdfID = faturainfo.PdfID;
      var prm = {
        id: faturainfo.EFaturaID,
        guid: faturainfo.FaturaGuid,
      };

      this.$refs.reportbrosablon.Print(prm).then((confirm) => {
        if (confirm.sonuc == true) {
        } else {
          this.text1 = confirm.mesaj;
          this.snackbar = true;
        }
      });
    },
    xsltsec(Faturaid) {
      this.dizaynsec.forEach((element) => {
        if (element.FaturaId == Faturaid) {
          this.faturaList.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId;
          this.faturaList.FaturaBilgi.FaturaPdfID = element.FaturaPdfID;
        }
      });
    },
    cariat(val) {
      this.faturaList.Filtreler.BitisCariKod = val;
      this.$refs.bitisCariAyarla.carigetir(
        this.faturaList.Filtreler.BaslangicCariKod
      );
    },

    kurgetir(kod) {
      var params1 = {
        Tarih: this.faturaList.FaturaTarih,
        DovizKod: kod,
      };

      this.$http
        .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
          headers: auth.getAuthCompaniesInfo()
        })
        .then(
          (response) => {
          if(response.body == 0.0){
           this.faturaList.DovizBilgi.DKur = 1
          }else{
          this.faturaList.DovizBilgi.DKur = response.body
          }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            }
          }
        );
    },
    mesajiptal() {
      this.faturadialog = false;
    },
    opsiyoniptal() {
      this.dialogopsiyon = false;
      this.faturaList = this.cancelValue;
    },
    faturalasor() {
      if (this.faturaList.GibSeri != null || this.faturaList.GibSeri != '') {
        if (
          this.faturaList.FaturaBilgi.FaturaID != null &&
          this.faturaList.FaturaBilgi.FaturaID != "" &&
          this.faturaList.FaturaBilgi.FaturaID != 0
        ) {
          this.xsltsec(this.faturaList.FaturaBilgi.FaturaID);

          this.faturadialog = true;
          this.dialogmesajı = this.$t('you-sure-that-want-invoice-your-tickets-your-selections');
        } else {
          this.text1 = this.$t('Please-choose-invoice-design');
          this.snackbar = true;
        }
      } else {
        this.text1 = this.$t('Please-select-GIB-series');
        this.snackbar = true;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.itemsTicket.slice();
    },
    dizayngetir() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.dizaynsec.length = 0
      this.faturaList.FaturaBilgi.FaturaID = null
      var params = {
        SirketKodu: credentials.SirketKodu,
        FaturaTip: "O",
        HatTipi: this.faturaList.Filtreler.HatBilgi,
        TumFiltre: true,
        DovizliFatura: false,
      };

      this.$http
        .post(auth.API_URL + "api/TicketInvoice/InvoiceMainTableList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dizaynsec = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.progress = false;
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            }
          }
        );
    },
    getList: getList,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
    faturala: faturala,
    efaturagoster: efaturagoster,
    opsiyonlarial: opsiyonlarial,
  },
};

function opsiyonlarial() {
  this.cancelValue = JSON.parse(JSON.stringify(this.faturaList));

  this.faturaList.FaturaTarih = getDateNow();

  this.dizayngetir();

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.faturaList.GibSeri = null
  if (this.faturaList.Filtreler.EFaturaKayitli == false) {
    var paramsEarchive = {
      CompanyCode: credentials.SirketKodu,
      PassiveControl: true,
    };
    this.$http.post(auth.API_URL + "api/Definitions/GibSerialEarchiveList", paramsEarchive, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if(response.body.length == 1){
              this.faturaList.GibSeri = response.body[0].Seri 
          }
              this.gibSeri1 = response.body;

        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        }
      );
  } else {
    var paramsEBiil = {
      CompanyCode: credentials.SirketKodu,
      PassiveControl: true,
    };

    this.$http.post(auth.API_URL + "api/Definitions/GibSerialList", paramsEBiil, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if(response.body.length == 1){
              this.faturaList.GibSeri = response.body[0].Seri 
          }
           this.gibSeri1 = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        }
      );
  }

      if(this.faturaList.Filtreler.BaslangicCariKod == this.faturaList.Filtreler.BitisCariKod && this.faturaList.Filtreler.BaslangicCariKod != null){
        this.isCurrentSame = true;
      }else{
        this.isCurrentSame = false;
        this.changeTitleInfo = false;
      }
  this.dialogopsiyon = true;
}

function filtrele() {

  if(this.faturaList.Filtreler.BaslangicCariKod == undefined ||
    this.faturaList.Filtreler.BitisCariKod == undefined ||
    this.faturaList.Filtreler.BaslangicCariKod == null ||
    this.faturaList.Filtreler.BitisCariKod == null 
    ){
      this.faturaList.EFaturaBilgi.Unvani = null;
      this.faturaList.EFaturaBilgi.Unvani2 = null;
      this.faturaList.EFaturaBilgi.Adres1 = null;
      this.faturaList.EFaturaBilgi.Adres2 = null;
      this.faturaList.EFaturaBilgi.IlceSehir = null;
      this.faturaList.EFaturaBilgi.VergiDairesi = null;
      this.faturaList.EFaturaBilgi.VergiNo = null;
      this.faturaList.EFaturaBilgi.TcKimlikNo = null;
      this.faturaList.EFaturaBilgi.Adi = null;
      this.faturaList.EFaturaBilgi.Soyadi = null;
      this.faturaList.EFaturaBilgi.TUnvani = null;
      this.faturaList.EFaturaBilgi.DigerAdi = null;
      this.faturaList.EFaturaBilgi.OnAdiEki = null;
      this.faturaList.EFaturaBilgi.Email = null;
      this.isCurrentSame = false;
      this.changeTitleInfo = false;
    }
  
  this.anaCancelValue = JSON.parse(JSON.stringify(this.faturaList));

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params1 = {
    CompanyCode: credentials.SirketKodu,
  };

  this.$http
    .post(auth.API_URL + "api/TicketDefinitons/AirlineList", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.itemsairlinelist = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.progress = false;

          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.progress = false;

          this.snackbar = true;
        }
      }
    );

  this.$http
    .post(auth.API_URL + "api/TicketHelpers/GetCrsList", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        var i = 0;
        response.body.forEach((element) => {
          var yeni = {
            text: element,
            value: i,
          };
          this.gdsitems.push(yeni);
          i = i + 1;
        });
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.progress = false;

          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.progress = false;

          this.snackbar = true;
        }
      }
    );

  // if (this.faturaList.Filtreler.EFaturaKayitli == true) {
  //   var params1 = {
  //     CompanyCode: credentials.SirketKodu,
  //     PassiveControl: true,
  //   };
  //   this.$http
  //     .post(auth.API_URL + "api/Definitions/GibSerialEarchiveList", params1, {
  //       headers: {
  //         Authorization: "Bearer " + auth.getAuthHeader(),
  //       },
  //     })
  //     .then(
  //       (response) => {
  //         this.gibSeri = response.body;
  //       },
  //       (response) => {
  //         if (response.status === 0) {
  //           this.text1 = "Service Unavailable";
  //           this.snackbar = true;
  //         } else {
  //           this.text1 = "Service Unavailable";
  //           this.snackbar = true;
  //         }
  //       }
  //     );
  // }

  this.dialogfiltre = true;
  var params3 = {
    CompanyCode: credentials.SirketKodu,
  };

  // this.$http
  //   .post(auth.API_URL + "api/Reference/List", params3, {
  //     headers: {
  //       Authorization: "Bearer " + auth.getAuthHeader(),
  //     },
  //   })
  //   .then(
  //     (response) => {
  //       this.Referans = response.body;
  //     },
  //     (response) => {
  //       if (response.status === 0) {
  //         this.text1 = "Service Unavailable";
  //         this.snackbar = true;
  //       } else {
  //         this.text1 = "Service Unavailable";
  //         this.snackbar = true;
  //       }
  //     }
  //   );

  this.$http
    .post(auth.API_URL + "api/TicketInvoice/InvoiceXsltTableList", params3, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.xsltitems = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.progress = false;
          this.text1 = "Service Unavailable-InvoiceXsltTableList";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-InvoiceXsltTableList";
          this.snackbar = true;
        }
      }
    );

  this.$http
    .post(auth.API_URL + "api/ExpenseCenter/List", params3, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.masrafmerkezi = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );

  this.$http
    .post(auth.API_URL + "api/Definitions/CurrentGroupList", params3, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.hesapgurubu = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );

  this.$http
    .post(auth.API_URL + "api/doctype/List", params3, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.evraktipi = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );
}

function filtrekayit() {
  this.filtreok = true;
  this.dialogfiltre = false;
}

function filtreiptal() {
  this.faturaList = this.anaCancelValue;
  this.filtreok = false 
  this.dialogfiltre = false

  this.faturaList.FaturaTarih = getDateNow();

}

function getList() {
  
  this.kayitvarmi = false;
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.dialogfiltre = false;
  this.yedekClass = this.faturaList;
  this.faturadialog = false;
  var tmpTicketList =[];
  this.itemsTicket = [];
  this.faturaItems = [];
  this.faturaSonView = false;
  this.selected = [];
  this.faturaList.SirketKodu = credentials.SirketKodu;
  this.faturaList.FaturaTarih = null;
  var params = this.faturaList;
  this.load1 = false;
  var tmpTicket={
        SirketKodu: 0,
        BiletNo: "",
        FormNo: "",
        HavaYoluKodu: "",
        UcusTip: null,
        OdemeTarihi: "",
        CariKod: null,
        OnlyCariKod: "",
        NetTutar: 0.0,
        KdvTutar: 0.0,
        ServisTutar: 0.0,
        YolcuAdi: "",
        Parkurlar: "",
        RezervasyonVeren: "",
        RezervasyonAlan: "",
        BiletKod:""
  }
  this.$http
    .post(auth.API_URL + "api/TicketInvoice/InvoiceSerialTicketList", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        if (response.body.length > 0) {
          tmpTicketList = response.body;

          tmpTicketList.forEach((value, index) => {
            this.itemsTicket.push({
              SirketKodu: value.SirketKodu,
        BiletNo: value.BiletNo,
        FormNo: value.FormNo,
        HavaYoluKodu: value.HavaYoluKodu,
        UcusTip: value.UcusTip,
        OdemeTarihi: value.OdemeTarihi,
        CariKod: value.CariKod,
        OnlyCariKod: value.OnlyCariKod,
        NetTutar: value.NetTutar,
        KdvTutar: value.KdvTutar,
        ServisTutar: value.ServisTutar,
        YolcuAdi: value.YolcuAdi,
        Parkurlar: value.Parkurlar,
        RezervasyonVeren: value.RezervasyonVeren,
        RezervasyonAlan: value.RezervasyonAlan,
        BiletKod:value.HavaYoluKodu + value.BiletNo
      });
});

          
          this.secilibutonshow = true;
          if (
            this.faturaList.Filtreler.BaslangicCariKod != null &&
            this.faturaList.Filtreler.BitisCariKod != null &&
            this.faturaList.Filtreler.BaslangicCariKod ==
              this.faturaList.Filtreler.BitisCariKod
          ) {
            this.carilerayni = true;
            this.load1 = true;
            this.kayitvarmi = true;
            this.kayitvarmesaj =
              this.$t('Invoice-has-yet-be-completed') +
               this.$t('records found. Please tickets to be invoiced',{value: response.body.length}) ;
          } else {
            this.carilerayni = false;
            this.selected = response.body;
            this.load1 = true;
            this.kayitvarmi = true;
            this.kayitvarmesaj =
             this.$t('Invoice-has-yet-be-completed') +
              response.body.length +
              " " + this.$t('Number-of-Records-Found');

            // this.faturala();
          }
        } else {
          this.kayitvarmi = false;
          this.kayitvarmesaj = "";
          this.text1 = this.$t('No-records-found-invoiced');
          this.dialogfiltre = false;
          this.snackbar = true;
          this.load1 = true;
          this.secilibutonshow = false;
        }
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-InvoiceSerialTicketList";
          this.snackbar = true;
          this.load1 = true;
        } else {
          this.text1 = "Service Unavailable-InvoiceSerialTicketList";
          this.snackbar = true;
          this.load1 = true;
        }
      }
    );
}

function faturala() {
  this.loadingvmodel = true;

  this.dialogopsiyon = false;
  this.faturadialog = false;
  this.carilerayni = false;
  this.load1 = false;
  this.secilibutonshow = false;
  
  var params = {
    ticketList: this.selected,
    invoiceInput: this.yedekClass,
  };
  params.invoiceInput.Filtreler.UnvanDegistir = this.changeTitleInfo;
  this.$http
    .post(auth.API_URL + "api/TicketInvoice/InvoiceSerialSave", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.loadingvmodel = false;

        if (response.body.length > 0) {
          this.faturaSonView = true;
          this.kayitvarmesaj = "İşlem tamamlandı.";
          this.faturaItems = response.body;
          this.load1 = true;
        } else {
          this.kayitvarmesaj = this.$t('No-records-have-been-invoiced');
          this.faturaSonView = false;
          this.load1 = true;
        }
      },
      (response) => {
        this.loadingvmodel = false;

        if (response.status === 0) {
          let data ={
          response: response,
          request: params,
          api:'InvoiceSerialSave',
          type:1,
          message: response.body.ExceptionMessage
          };
          this.$refs.showMessage.open(data);
          this.kayitvarmesaj = this.$t('Error');
          this.secilibutonshow = true;

          this.text1 = "Service Unavailable-InvoiceSerialSave";
          this.snackbar = true;
          this.load1 = true;
        } else {
          this.kayitvarmesaj = this.$t('Error');
          this.secilibutonshow = true;

          this.text1 = "Service Unavailable-InvoiceSerialSave";
          this.snackbar = true;
          this.load1 = true;
        }
      }
    );
}

function efaturagoster(v) {
  var params = {
    id: v.EFaturaID,
    guid: v.FaturaGuid,
  };

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.$http
    .post(auth.API_URL + "api/EFatura/FaturaShow", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: credentials.SirketKodu.toString(),
        CoperSirketNo: credentials.CoperSirketNo.toString(),
      },
    })
    .then(
      (response) => {
        this.faturadialoggoster = true;
        document.getElementById("demo2").innerHTML = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-Fatura Show";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-Fatura Show";
          this.snackbar = true;
        }
      }
    );
}

function beforeMount() {}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}
</script>

<style></style>
